var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.125,
    height: 12.75,
    viewBox: "0 0 19.125 12.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-eye",
    transform: "translate(0 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13440",
    "data-name": "Path 13440",
    d: "M18.488,13.275a.637.637,0,1,0,.638.637A.637.637,0,0,0,18.488,13.275Zm-17.85,0a.637.637,0,1,0,.638.637.637.637,0,0,0-.638-.637ZM9.563,12a1.912,1.912,0,1,0,1.913,1.912A1.912,1.912,0,0,0,9.563,12Z",
    transform: "translate(0 -2.537)",
    fill: "#533ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13441",
    "data-name": "Path 13441",
    d: "M19.059,11s-3.7-6-9.437-6S.185,11,.185,11l-.022.724S3.247,17.75,9.622,17.75s9.459-6.028,9.459-6.028Zm-9.437,4.84a4.463,4.463,0,1,1,4.462-4.462A4.462,4.462,0,0,1,9.622,15.838Z",
    transform: "translate(-0.059)",
    fill: "#533ffb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b2a950cc2a6ffed22e2d9920bee37eb4.svg";
export { ForwardRef as ReactComponent };